import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=997053de&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=997053de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997053de",
  null
  
)

export default component.exports